import { render, staticRenderFns } from "./mzj_Main.vue?vue&type=template&id=cc9d8ba8&scoped=true&"
import script from "./mzj_Main.vue?vue&type=script&lang=js&"
export * from "./mzj_Main.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Main.vue?vue&type=style&index=0&id=cc9d8ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9d8ba8",
  null
  
)

export default component.exports